/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import * as com_amazon_coral_availability from "@amzn/coral_com-amazon-coral-availability";
import { RejectReportOutput } from "./RejectReportOutput";
import { BuildDataPipelinesInput } from "./BuildDataPipelinesInput";
import { InitiateBatchReportUploadOutput } from "./InitiateBatchReportUploadOutput";
import { CreateReportApprovalOutput } from "./CreateReportApprovalOutput";
import { DownloadReportInput } from "./DownloadReportInput";
import { TRCSRecoverableException } from "./TRCSRecoverableException";
import { CompleteBatchReportUploadInput } from "./CompleteBatchReportUploadInput";
import { UploadReportOutput } from "./UploadReportOutput";
import { SearchReportsOutput } from "./SearchReportsOutput";
import { TRCSUnauthorizedException } from "./TRCSUnauthorizedException";
import { TRCSInvalidRequestException } from "./TRCSInvalidRequestException";
import { InitiateBatchReportUploadInput } from "./InitiateBatchReportUploadInput";
import { GenerateReportSyncInput } from "./GenerateReportSyncInput";
import { TRCSUnrecoverableException } from "./TRCSUnrecoverableException";
import { CreateReportApprovalInput } from "./CreateReportApprovalInput";
import { GeneratePresignedUrlOutput } from "./GeneratePresignedUrlOutput";
import { GenerateReportAsyncInput } from "./GenerateReportAsyncInput";
import { GenerateReportAsyncOutput } from "./GenerateReportAsyncOutput";
import { CompleteBatchReportUploadOutput } from "./CompleteBatchReportUploadOutput";
import { RejectReportInput } from "./RejectReportInput";
import { SearchReportsInput } from "./SearchReportsInput";
import { GetTermReportConfigsInput } from "./GetTermReportConfigsInput";
import { GetTermReportConfigsOutput } from "./GetTermReportConfigsOutput";
import { BuildDataPipelinesOutput } from "./BuildDataPipelinesOutput";
import { UploadReportInput } from "./UploadReportInput";
import { DependencyException } from "./DependencyException";
import { ApproveReportInput } from "./ApproveReportInput";
import { DeleteReportInput } from "./DeleteReportInput";
import { ApproveReportOutput } from "./ApproveReportOutput";
import { BeerList } from "./BeerList";
import { GenerateReportSyncOutput } from "./GenerateReportSyncOutput";
import { Beer } from "./Beer";
import { DeleteReportOutput } from "./DeleteReportOutput";
import { GeneratePresignedUrlInput } from "./GeneratePresignedUrlInput";
import { DownloadReportOutput } from "./DownloadReportOutput";
import * as com_amazon_coral_service_bsf from "@amzn/coral_com-amazon-coral-service-bsf";
import * as com_amazon_coral_client from "@amzn/coral_com-amazon-coral-client";
import * as com_amazon_coral_service from "@amzn/coral_com-amazon-coral-service";
import * as com_amazon_coral_service_jms from "@amzn/coral_com-amazon-coral-service-jms";
import * as com_amazon_coral_validate from "@amzn/coral_com-amazon-coral-validate";
import * as com_amazon_coral_service_http from "@amzn/coral_com-amazon-coral-service-http";
import { CoralClient, CoralResponse, } from "@amzn/ihm-js-coral-client";
import { CoralClientHttpBindingInterceptor, CoralClientSerdesInterceptor, InterceptingHandler, } from "@amzn/ihm-js-coral-client";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
export const transReportsCenterServiceSerdesInterceptor = new CoralClientSerdesInterceptor({
    ApproveReport: {
        deserializationFn: ApproveReportOutput.fromJson,
        serializationFn: ApproveReportInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    BuildDataPipelines: {
        deserializationFn: BuildDataPipelinesOutput.fromJson,
        serializationFn: BuildDataPipelinesInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    CompleteBatchReportUpload: {
        deserializationFn: CompleteBatchReportUploadOutput.fromJson,
        serializationFn: CompleteBatchReportUploadInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    CreateBeer: {
        deserializationFn: Beer.fromJson,
        serializationFn: Beer.toJson,
        modelledExceptions: [DependencyException],
    },
    CreateReportApproval: {
        deserializationFn: CreateReportApprovalOutput.fromJson,
        serializationFn: CreateReportApprovalInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    DeleteReport: {
        deserializationFn: DeleteReportOutput.fromJson,
        serializationFn: DeleteReportInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    DownloadReport: {
        deserializationFn: DownloadReportOutput.fromJson,
        serializationFn: DownloadReportInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    GeneratePresignedUrl: {
        deserializationFn: GeneratePresignedUrlOutput.fromJson,
        serializationFn: GeneratePresignedUrlInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    GenerateReportAsync: {
        deserializationFn: GenerateReportAsyncOutput.fromJson,
        serializationFn: GenerateReportAsyncInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    GenerateReportSync: {
        deserializationFn: GenerateReportSyncOutput.fromJson,
        serializationFn: GenerateReportSyncInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    GetAllBeers: {
        deserializationFn: BeerList.fromJson,
        modelledExceptions: [DependencyException],
    },
    GetTermReportConfigs: {
        deserializationFn: GetTermReportConfigsOutput.fromJson,
        serializationFn: GetTermReportConfigsInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    InitiateBatchReportUpload: {
        deserializationFn: InitiateBatchReportUploadOutput.fromJson,
        serializationFn: InitiateBatchReportUploadInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    RejectReport: {
        deserializationFn: RejectReportOutput.fromJson,
        serializationFn: RejectReportInput.toJson,
        modelledExceptions: [],
    },
    SearchReports: {
        deserializationFn: SearchReportsOutput.fromJson,
        serializationFn: SearchReportsInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
    UploadReport: {
        deserializationFn: UploadReportOutput.fromJson,
        serializationFn: UploadReportInput.toJson,
        modelledExceptions: [
            TRCSUnrecoverableException,
            TRCSUnauthorizedException,
            TRCSInvalidRequestException,
            TRCSRecoverableException,
        ],
    },
}, [
    com_amazon_coral_availability.BackOffException,
    com_amazon_coral_availability.ThrottlingException,
    com_amazon_coral_client.ClientUnavailableException,
    com_amazon_coral_client.HttpConnectionTimeoutException,
    com_amazon_coral_client.HttpFailureException,
    com_amazon_coral_client.HttpTimeoutException,
    com_amazon_coral_service_bsf.InvalidCodigoMessageException,
    com_amazon_coral_service_http.HeaderMisclassificationException,
    com_amazon_coral_service_http.HttpNotFoundException,
    com_amazon_coral_service_http.InvalidAuthSchemeException,
    com_amazon_coral_service_http.InvalidAuthSchemeParameterException,
    com_amazon_coral_service_http.InvalidMessageDigestException,
    com_amazon_coral_service_http.MissingAuthSchemeParameterException,
    com_amazon_coral_service_http.MissingMessageDigestException,
    com_amazon_coral_service_http.MissingRequiredHeaderException,
    com_amazon_coral_service_jms.MessageProcessingException,
    com_amazon_coral_service_jms.MessagePublishException,
    com_amazon_coral_service.AccessDeniedException,
    com_amazon_coral_service.DelegationException,
    com_amazon_coral_service.ExpiredTokenException,
    com_amazon_coral_service.IncompleteSignatureException,
    com_amazon_coral_service.InternalFailure,
    com_amazon_coral_service.InvalidAwsQueryStringException,
    com_amazon_coral_service.InvalidParameterCombinationException,
    com_amazon_coral_service.InvalidParameterValueException,
    com_amazon_coral_service.InvalidQueryParameterException,
    com_amazon_coral_service.InvalidQueryStringException,
    com_amazon_coral_service.InvalidSignatureException,
    com_amazon_coral_service.MalformedHttpRequestException,
    com_amazon_coral_service.MissingActionException,
    com_amazon_coral_service.MissingAuthenticationTokenException,
    com_amazon_coral_service.MissingRequiredParameterException,
    com_amazon_coral_service.NotAuthorizedException,
    com_amazon_coral_service.RequestAbortedException,
    com_amazon_coral_service.RequestEntityTooLargeException,
    com_amazon_coral_service.RequestExpiredException,
    com_amazon_coral_service.RequestTimeoutException,
    com_amazon_coral_service.SerializationException,
    com_amazon_coral_service.ServiceUnavailableException,
    com_amazon_coral_service.SubscriptionRequiredException,
    com_amazon_coral_service.TimeoutException,
    com_amazon_coral_service.TransmutationException,
    com_amazon_coral_service.UnknownOperationException,
    com_amazon_coral_service.UnrecognizedClientException,
    com_amazon_coral_service.UnsupportedMediaTypeException,
    com_amazon_coral_validate.ValidationException,
]);
export const transReportsCenterServiceHttpBindingInterceptor = new CoralClientHttpBindingInterceptor({
    ApproveReport: {
        method: "POST",
        path: "/trcs/v1/reports/approve-report",
    },
    BuildDataPipelines: {
        method: "POST",
        path: "/trcs/v1/data-pipelines",
    },
    CompleteBatchReportUpload: {
        method: "POST",
        path: "/trcs/v1/reports/complete-batch-upload",
    },
    CreateReportApproval: {
        method: "POST",
        path: "/trcs/v1/reports/create-approval",
    },
    DeleteReport: {
        method: "POST",
        path: "/trcs/v1/reports/delete",
    },
    DownloadReport: {
        method: "POST",
        path: "/trcs/v1/reports/download",
    },
    GeneratePresignedUrl: {
        method: "POST",
        path: "/trcs/v1/generate-url",
    },
    GenerateReportAsync: {
        method: "POST",
        path: "/trcs/v1/reports/generate-async",
    },
    GenerateReportSync: {
        method: "POST",
        path: "/trcs/v1/reports/generate-sync",
    },
    GetTermReportConfigs: {
        method: "POST",
        path: "/trcs/v1/report-configs",
    },
    InitiateBatchReportUpload: {
        method: "POST",
        path: "/trcs/v1/reports/batch-upload",
    },
    RejectReport: {
        method: "POST",
        path: "/trcs/v1/reports/reject-report",
    },
    SearchReports: {
        method: "POST",
        path: "/trcs/v1/reports/search",
    },
    UploadReport: {
        method: "POST",
        path: "/trcs/v1/reports/upload",
    },
});
export class TransReportsCenterService extends CoralClient {
    constructor(config, handler) {
        const serdesHandler = new InterceptingHandler(handler, [
            transReportsCenterServiceSerdesInterceptor,
        ]);
        super(config, serdesHandler);
    }
    /**
     * <pre><code>API to approve the uploaded document.
     * <\/code><\/pre>
     **/
    approveReport(request) {
        return super.call("ApproveReport", request).pipe(map(({ body }) => {
            if (!(body instanceof ApproveReportOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type ApproveReportOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <pre><code>API  to build data pipelines for given term and reportType.
     * <\/code><\/pre>
     **/
    buildDataPipelines(request) {
        return super.call("BuildDataPipelines", request).pipe(map(({ body }) => {
            if (!(body instanceof BuildDataPipelinesOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type BuildDataPipelinesOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API called to complete report multipart upload
     * Till this API is called report upload is not considered to be completed
     * Takes eTags of the parts of each report that are uploaded successfully along with unique uploadId<\/p>
     **/
    completeBatchReportUpload(request) {
        return super.call("CompleteBatchReportUpload", request).pipe(map(({ body }) => {
            if (!(body instanceof CompleteBatchReportUploadOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type CompleteBatchReportUploadOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>Create a new beer<\/p>
     **/
    createBeer(request) {
        return super.call("CreateBeer", request).pipe(map(({ body }) => {
            if (!(body instanceof Beer)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type Beer. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <pre><code>API to create approval request for report uploaded.
     * <\/code><\/pre>
     **/
    createReportApproval(request) {
        return super.call("CreateReportApproval", request).pipe(map(({ body }) => {
            if (!(body instanceof CreateReportApprovalOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type CreateReportApprovalOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <pre><code>For given input deletes report and its record.
     * <\/code><\/pre>
     **/
    deleteReport(request) {
        return super.call("DeleteReport", request).pipe(map(({ body }) => {
            if (!(body instanceof DeleteReportOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type DeleteReportOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API to download the report<\/p>
     **/
    downloadReport(request) {
        return super.call("DownloadReport", request).pipe(map(({ body }) => {
            if (!(body instanceof DownloadReportOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type DownloadReportOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <pre><code>API to generate pre-signed URL for given S3 details.
     * <\/code><\/pre>
     **/
    generatePresignedUrl(request) {
        return super.call("GeneratePresignedUrl", request).pipe(map(({ body }) => {
            if (!(body instanceof GeneratePresignedUrlOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GeneratePresignedUrlOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API to generate report asynchronously.<\/p>
     **/
    generateReportAsync(request) {
        return super.call("GenerateReportAsync", request).pipe(map(({ body }) => {
            if (!(body instanceof GenerateReportAsyncOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GenerateReportAsyncOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API to generate report synchronously.<\/p>
     **/
    generateReportSync(request) {
        return super.call("GenerateReportSync", request).pipe(map(({ body }) => {
            if (!(body instanceof GenerateReportSyncOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GenerateReportSyncOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>Get a list of all of the beers in the system<\/p>
     **/
    getAllBeers() {
        return super.call("GetAllBeers").pipe(map(({ body }) => {
            if (!(body instanceof BeerList)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type BeerList. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API to fetch all available report types configurations of a term<\/p>
     **/
    getTermReportConfigs(request) {
        return super.call("GetTermReportConfigs", request).pipe(map(({ body }) => {
            if (!(body instanceof GetTermReportConfigsOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GetTermReportConfigsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API to initiate Batch report uploads
     * Each report of the Batch is uploaded via mutlipart upload
     * Takes list of each report specific input and returns list of presigned URLs to upload each part of the report<\/p>
     **/
    initiateBatchReportUpload(request) {
        return super.call("InitiateBatchReportUpload", request).pipe(map(({ body }) => {
            if (!(body instanceof InitiateBatchReportUploadOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type InitiateBatchReportUploadOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <pre><code>API to reject the uploaded document.
     * <\/code><\/pre>
     **/
    rejectReport(request) {
        return super.call("RejectReport", request).pipe(map(({ body }) => {
            if (!(body instanceof RejectReportOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type RejectReportOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <pre><code>Fetches reports information for given search input. Its a paginated API.
     * Note: Keeping the verb as POST to support additional search inputs in future
     * <\/code><\/pre>
     **/
    searchReports(request) {
        return super.call("SearchReports", request).pipe(map(({ body }) => {
            if (!(body instanceof SearchReportsOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type SearchReportsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API  to initiate report upload
     * This upload can be used to either upload a file or folder object<\/p>
     **/
    uploadReport(request) {
        return super.call("UploadReport", request).pipe(map(({ body }) => {
            if (!(body instanceof UploadReportOutput)) {
                throw new TypeError(`[TransReportsCenterService] Expected response body to be of type UploadReportOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
}
TransReportsCenterService.assembly = "com.amazon.transreportscenterservice";
TransReportsCenterService.serviceName = "TransReportsCenterService";
